// extracted by mini-css-extract-plugin
export default {"editor":"Wysiwyg_editor__AAtc8","toolbar":"Wysiwyg_toolbar__TQkwB"};